import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import styles from './styles/feature-card.module.css';

export default function FeatureCard({ type, title, subTitle, Image, SecondImage, ThirdImage, FourImage, cardMotionVariant, imgMotion, secondImgMotion, thirdImgMotion, fourImgMotion, contentMotion }) {
    const cardRef = useRef(null);

    const cardInView = useInView(cardRef, {
        once: true,
        amount: 0.1,
        margin: '-100px 0px'
    });

    return (
        <motion.div
            ref={cardRef}
            className={styles.wrapper}
            data-type={type}
            initial={cardMotionVariant?.initial}
            animate={cardInView ? cardMotionVariant?.animate : cardMotionVariant?.initial}
            transition={{ ...cardMotionVariant?.transition }}
        >
            <motion.div
                className={styles.boxTitle}
                initial={contentMotion?.initial}
                animate={cardInView ? contentMotion?.animate : contentMotion?.initial}
                transition={contentMotion?.transition}
            >
                <p>{title}</p>
                <p>{subTitle}</p>
            </motion.div>
            <motion.div
                className={styles.boxImg}
                data-type={type}
                initial={contentMotion?.initial}
                animate={cardInView ? contentMotion?.animate : contentMotion?.initial}
                transition={contentMotion?.transition}
            >
                <div>
                    <motion.div
                        initial={imgMotion?.initial}
                        animate={cardInView ? imgMotion?.animate : imgMotion?.initial}
                        transition={imgMotion?.transition}
                    >
                        <Image />
                    </motion.div>
                </div>
                {SecondImage && 
                    <motion.div
                        initial={secondImgMotion?.initial}
                        animate={cardInView ? secondImgMotion?.animate : secondImgMotion?.initial}
                        transition={secondImgMotion?.transition}
                    >
                        <SecondImage />
                    </motion.div>
                }
                {ThirdImage && 
                    <motion.div
                        initial={thirdImgMotion?.initial}
                        animate={cardInView ? thirdImgMotion?.animate : thirdImgMotion?.initial}
                        transition={thirdImgMotion?.transition}
                    >
                        <ThirdImage />
                    </motion.div>
                }
                {FourImage && 
                    <motion.div
                        initial={fourImgMotion?.initial}
                        animate={cardInView ? fourImgMotion?.animate : fourImgMotion?.initial}
                        transition={fourImgMotion?.transition}
                    >
                        <FourImage />
                    </motion.div>
                }
            </motion.div>
        </motion.div>
    );
}
